<template>
  <select-form
    :name="fieldName"
    :validator="validator"
    :dispatcher="dispatcher"
    :selectable-items="positionTypes"
    :default-item="defaultItem"
  />
</template>

<script setup>
import {
  usePositionTypeField,
  usePositionTypeStore
} from "@component_path/agent_selection_wish_module/custom_hook/PositionType";

import SelectForm from "@component_path/pages/pc/agent_selection/secret/components/form_element/Select";
import { watch } from "vue";

const props = defineProps({
  required: {
    type: Boolean,
    required: false,
    default: false
  },
  defaultItem: {
    type: Object,
    required: false
  }
});

const { validator, fieldName } = usePositionTypeField(props.required);
const { dispatcher, positionTypes } = usePositionTypeStore();
</script>
